<template>
  <TeaserGroupList
    :title="state.title"
    :teasers="state.teasers"
    class="is--full-detail-width-small"
    :analytics="{ linkAnalyticsTag: 'content-teasers' }"
  />
</template>

<script setup lang="ts">
import type { ICmsContentTeasers } from '~~/types/_cms-types';
import type { ITeaser } from '~~/types/local_types';
const props = defineProps<ICmsContentTeasers>();

const articles = (props.articles ?? [])
  .filter((article) => !!article?.articlesId)
  .map((article) => article.articlesId as ITeaser);

const externalLinks = (props.externalLinks ?? [])
  .filter((externalLink) => !!externalLink?.externalLinksId)
  .map((externalLink) => {
    const { title, url } = externalLink.externalLinksId!;
    return {
      articleType: 'externe-link',
      title,
      slug: url || '',
      externalUrl: url || '',
      publishTime: undefined,
    } as ITeaser;
  });

const teasers = ref<ITeaser[]>([...articles, ...externalLinks]);

interface IState {
  title: string;
  teasers: ITeaser[];
}

const state = reactive<IState>({
  title: (props as { title: string }).title || '',
  teasers: teasers.value || [],
});
</script>
